module.exports = __webpack_public_path__ + "img/substation-img_1.77f4a70e.png";